import ApiService from "../../services/ApiService"
import { isLoading, setError, setSuccessMessage } from "./uxAction"

export function createIndustry({ industryName }, callback) {
    return async (dispatch) => {
        dispatch(isLoading(true))

        const resp = await ApiService.invokePost(process.env.REACT_APP_API_URL + `/admin/api/secured/industry`, {
            industryName
        })

        if (resp.status >= 400) {
            dispatch(setError(resp.data.errors))
        }

        dispatch(isLoading(false))

        if (callback)
            callback(resp.data.data)
    }
}

export function fetchAllIndustries({ query, page = 0, limit = 20 }, callback) {
    return async (dispatch) => {
        dispatch(isLoading(true))

        const resp = await ApiService.invokeGet(process.env.REACT_APP_API_URL + `/admin/api/secured/industry?query=${query}&page=${page}&limit=${limit}`)

        dispatch(isLoading(false))

        if (resp.status === 200) {
            const { data } = resp.data
            await dispatch({
                type: 'FETCH_INDUSTRIES_TABLE',
                payload: data
            })


        if (callback)
            callback({
                filteredData: data.filteredData,
                totalFiltered: data.filteredData?.length,
                total: data.total
            })
        }
    }
}

export function bulkDeleteIndustry({ industryIds = [] }, callback) {
    return async (dispatch) => {
        try {
            dispatch(isLoading(true))

            const resp = await ApiService.invokeDelete(process.env.REACT_APP_API_URL + `/admin/api/secured/industries`, {
                industryIds
            })

            dispatch(isLoading(false))

            if (resp.status == 200) {
                dispatch(setSuccessMessage({
                    title: "Success",
                    subTitle: "Item(s) deleted"
                }))
            }

            if (callback)
                callback()

        } catch (e) { }
    }
}

export function updateIndustry({ industryId, industryName }, callback) {
    return async (dispatch) => {
        try {
            dispatch(isLoading(true))

            const resp = await ApiService.invokePatch(process.env.REACT_APP_API_URL + `/admin/api/secured/industries/${industryId}`, {
                industryName
            })

            dispatch(isLoading(false))

            if (resp.status >= 400)
                dispatch(setError(resp.data.errors))

            if (resp.status == 200) {
                dispatch(setSuccessMessage({
                    title: "Success",
                    subTitle: "updated successfully"
                }))
            }

            if (callback)
                callback()


        } catch (e) { }
    }
}